'use client';

import { useContext } from 'react';

import type { WithID } from '@ps/models/lib/base';
import type { PrivateProfile } from '@ps/models/lib/private-profile';
import type { Profile } from '@ps/models/lib/profile';
import type { ReadonlyProfile } from '@ps/models/lib/readonly-profile';

import { UserProfileContext } from './context';

export * from './context';

export function useUserProfileContext() {
  const context = useContext(UserProfileContext);
  if (!context) {
    throw new Error(
      'useUserProfileContext must be used within a UserProfileProvider',
    );
  }
  return context;
}

export function useCurrentUserProfile(): WithID<Profile> | undefined {
  const { currentUserProfile } = useUserProfileContext();
  return currentUserProfile;
}

export function useCurrentUserPrivateProfile():
  | WithID<PrivateProfile>
  | undefined {
  const { currentUserPrivateProfile } = useUserProfileContext();
  return currentUserPrivateProfile;
}

export function useCurrentUserReadonlyProfile():
  | WithID<ReadonlyProfile>
  | undefined {
  const { currentUserReadonlyProfile } = useUserProfileContext();
  return currentUserReadonlyProfile;
}
